import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REF_KEY = "fmg_ref_code";
const REF_PATTERN = /^FMG-[A-Z0-9]{4,12}$/;

export function getCapturedReferralCode() {
  try {
    const v = (sessionStorage.getItem(REF_KEY) || "").trim().toUpperCase();
    return REF_PATTERN.test(v) ? v : null;
  } catch { return null; }
}

export function clearCapturedReferralCode() {
  try { sessionStorage.removeItem(REF_KEY); } catch { /* no-op */ }
}

// Captures the Advocate referral link parameter (?ref=FMG-XXXXXX) on any
// landing page (including the homepage) and preserves it for the visitor
// session so it survives navigation to /register.
export function ReferralCapture() {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const raw = (params.get("ref") || params.get("referral_code") || "").trim().toUpperCase();
    if (raw && REF_PATTERN.test(raw)) {
      try { sessionStorage.setItem(REF_KEY, raw); } catch { /* no-op */ }
    }
  }, [location.search]);
  return null;
}
